import { BankAccountTypeEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function bankAccountTypeOptions(): SelectOption<string>[] {
  return [
    BankAccountTypeEnum.savings_account,
    BankAccountTypeEnum.checking_account,
    BankAccountTypeEnum.deposit_account
  ].map((val: BankAccountTypeEnum) => {
    return { value: val, label: i18n.t(`bank-account.account-type.${val}`).toString() };
  });
}
